import React from "react";
import {
	Card,
	makeStyles,
	CardActionArea,
	Typography,
} from "@material-ui/core";

const useStyles = makeStyles({
	card: {
		display: "flex",
		flexDirection: "column",
	},
	cardAction: {
		height: 180,
	},
	cardMedia: (props: LoginOptionProps) => ({
		paddingTop: "100px",
		backgroundSize: props.size,
	}),
	content: {
		// height: 50
	},
	img: {
		margin: "auto",
		display: "block",
		maxWidth: "80%",
		flexShrink: 0,
	},
	text: {
		textAlign: "center",
	},
});

export interface LoginOptionProps {
	logoUrl?: string;
	size: string;
	onClick: any;
	text?: string;
}

const LoginOption = (props: LoginOptionProps) => {
	const { logoUrl, onClick, text } = props;
	const classes = useStyles(props);
	return (
		<Card className={classes.card} onClick={onClick}>
			<CardActionArea className={classes.cardAction}>
				{logoUrl && <img alt="logo" src={logoUrl} className={classes.img} />}
				{text && (
					<Typography variant="h4" className={classes.text}>
						{text}
					</Typography>
				)}
			</CardActionArea>
		</Card>
	);
};

export default LoginOption;
